import { GTConfirmationModality, GTDurationUnit } from 'gql/types.generated'

export const CONFIRMATION_MODALITIES_LIST = Object.values(GTConfirmationModality)
export const DURATION_UNIT_LIST = Object.values(GTDurationUnit)
